import { render, staticRenderFns } from "./id-card-exam.vue?vue&type=template&id=6b9492ce&scoped=true"
import script from "./id-card-exam.vue?vue&type=script&lang=ts"
export * from "./id-card-exam.vue?vue&type=script&lang=ts"
import style0 from "./id-card-exam.vue?vue&type=style&index=0&id=6b9492ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9492ce",
  null
  
)

export default component.exports